
import './App.css';
import Weather from './Weather';
function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultcity="Fargo" />
      </div>

      <footer>
        This project was coded by <a href="/">Milga Ahmed</a> and is{" "}
        <a href="https://github.com/ZaamiAhmed/global-weather">
          Open-sourced github
        </a>
      </footer>
    </div>
  );
}

export default App;
